export class WorkPlace {
  id: string;
  name: string;
  constructor(id: string, obj: any) {
    this.id = id;
    this.name = obj.name;
  }
}
